import faqSearch from '../faq-search.js'
import { scrollTo } from './scroll.js'

export default function helpSearch ($container, { $refs }) {
  let search = faqSearch($container)

  let $form = $refs.form[0]
  let $input = $refs.input[0]

  function onSubmit (e) {
    e.preventDefault()
    scrollTo($refs.faqs[0], {
      scrollMode: 'always',
      offset: 100
    })
  }

  function onInput (e) {
    e.preventDefault()

    search.search($input.value.trim())
  }

  $form.addEventListener('submit', onSubmit)
  $input.addEventListener('input', onInput)

  return () => {
    $form.removeEventListener('submit', onSubmit)
    $input.removeEventListener('submit', onInput)
  }
}



// WEBPACK FOOTER //
// ./src/js/components/help-search.js